import { createAction, props } from '@ngrx/store';
import { IContactState } from './contact.state';

export const initContactAction = createAction('[Contact Page] Contact page');

export const setContactAction = createAction(
  '[Contact Page] set data',
  props<IContactState>()
);
